const benefitsTabs = document.querySelectorAll('.wp-tabs-benefits')

benefitsTabs.forEach(benefitsTab => {
    const benefitIconGrids = benefitsTab.querySelectorAll('.wp-icon-grid');
    const buttonsPanel = benefitsTab.querySelector('.nav-tabs')

    benefitIconGrids.forEach((benefitIconGrid, index) => {
        const id = benefitIconGrid.getAttribute('id')
        const button = buttonsPanel.querySelector(`.nav-link:nth-child(${index+1})`)

        button.setAttribute('data-bs-target', `#${id}`)
    })
})